import React, { createContext, useContext, useState } from 'react';

const UnitsContext = createContext(null);

export const UnitsProvider = ({ children }) => {
  // Storage remains canonical (lbs, km, metres); presentation changes as one system.
  const [measurementSystem, setMeasurementSystem] = useState('imperial');
  const isImperial = measurementSystem === 'imperial';
  const weightUnit = isImperial ? 'lbs' : 'kg';
  const distanceUnit = isImperial ? 'mi' : 'km';
  const elevationUnit = isImperial ? 'ft' : 'm';

  const toggleMeasurementSystem = () => {
    setMeasurementSystem(previous => (previous === 'imperial' ? 'metric' : 'imperial'));
  };

  return (
    <UnitsContext.Provider value={{
      measurementSystem,
      weightUnit,
      distanceUnit,
      elevationUnit,
      setMeasurementSystem,
      toggleMeasurementSystem,
    }}>
      {children}
    </UnitsContext.Provider>
  );
};

export const useUnits = () => useContext(UnitsContext);

export default UnitsContext;
